var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H100V100H0V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5436 83.5673L34.1963 78.936C35.6727 81.5537 37.0157 83.7684 40.2371 83.7684C43.3251 83.7684 45.2719 82.5605 45.2719 77.8621V45.9097H54.6694V77.9949C54.6694 87.7283 48.964 92.1586 40.64 92.1586C33.1224 92.1586 28.7586 88.2651 26.5435 83.5665",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7738 82.5603L67.4255 78.13C69.4398 81.4195 72.0578 83.8359 76.6892 83.8359C80.583 83.8359 83.066 81.889 83.066 79.204C83.066 75.9819 80.5154 74.8406 76.2192 72.9617L73.8705 71.9541C67.0903 69.0683 62.5927 65.4435 62.5927 57.791C62.5927 50.7427 67.9627 45.3724 76.3538 45.3724C82.3281 45.3724 86.6241 47.4535 89.7116 52.8908L82.3948 57.5894C80.7836 54.7032 79.0389 53.5622 76.354 53.5622C73.6017 53.5622 71.8563 55.3075 71.8563 57.5894C71.8563 60.4087 73.6017 61.5502 77.6289 63.2956L79.9781 64.3024C87.9662 67.726 92.4638 71.2162 92.4638 79.0697C92.4638 87.5281 85.8184 92.1594 76.8908 92.1594C68.1644 92.1594 62.5257 87.9978 59.774 82.5603",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.54e62e57f85272f478764014fd24d91c.svg";
export { ForwardRef as ReactComponent };